import { useGLTF } from "@react-three/drei";
import * as THREE from "three";
import { useEffect } from "react";

interface PartModelProps {
  path: string;
  visible?: boolean;
  color?: string;
  isBase?: boolean;
}

export const PartModel: React.FC<PartModelProps> = ({
  path,
  visible = true,
  color,
  isBase = false,
}) => {
  const { scene } = useGLTF(path);

  useEffect(() => {
    scene.traverse((child) => {
      if (child instanceof THREE.Mesh) {
        // ✅ Base hand is ALWAYS visible
        child.visible = isBase ? true : visible;

        // clone material once
        child.material = child.material.clone();

        // 🎨 Apply skin color ONLY to base
        if (isBase) {
          child.material.color.set("#e0ac69"); // skin tone
          child.material.roughness = 0.65;
          child.material.metalness = 0.02;
        }

        // 🎨 Apply dynamic color ONLY to parts
        if (!isBase && color) {
          child.material.color.set(color);
        }
      }
    });
  }, [scene, visible, color, isBase]);

  return <primitive object={scene} />;
};
